import Colors from '../../../Configs/colors';

const styles = {
  root: {
    position: 'relative',
    marginTop: 16,
    '& .fancy-card': {
      background: Colors.pinkWhite,
      borderRadius: 8,
    },
    '& .storage-card': {
      borderRadius: 8,
      padding: '16px 12px',
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      border: '1px solid #F3F3F3',
      cursor: 'pointer',
    },
    '& .slider-container': {
      overflow: 'auto',
      flexWrap: 'nowrap',
      width: '100%',
      padding: 12,
      marginBottom: -12,
      boxSizing: 'border-box',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '& .storage-card': {
        '& .product-img': {
          height: 32,
          width: 32,
          objectFit: 'cover',
          borderRadius: 8,
        },
        padding: 12,
        background: '#fff',
        borderRadius: 8,
        fontSize: 16,
        width: 180,
        cursor: 'pointer',
        boxShadow: '0px 4px 12px rgba(7, 79, 147, 0.2)',
        '& .storage-q': {
          padding: '5px 12px',
          backgroundColor: Colors.pinkWhite,
          borderRadius: 8,
          color: Colors.redLight,
        },
        '& .user-identifier': {
          color: '#282828',
        },
        '& .storage-date': {
          fontSize: 12,
        },
      },
    },
  },
};

export default styles;
